"use client";

import React from "react";
import Link from "next/link";
import DownloadButton from "@/components/DownloadButton";

export default function Pricing() {
  return (
    <section className="section-container min-h-[60vh] flex flex-col items-center justify-center">
      <div className="max-w-3xl mx-auto text-center">
        <h1 className="text-3xl md:text-4xl font-press-start mb-6">PRICING</h1>

        <div className="bg-secondary rounded-xl p-8 md:p-12 shadow-md border-4 border-accent border-opacity-80 retro-shadow">
          <h2 className="text-2xl mb-4 font-press-start text-primary">
            FREE DURING BETA
          </h2>
          <p className="text-lg mb-6 font-vt323">
            We are still fine-tuning Takeoff and determining our pricing
            structure. For now, Takeoff is completely free to use!
          </p>
          <p className="text-base mb-8 text-text font-vt323">
            Get early access and help shape the future of AI-powered testing
            while we work on our official pricing plans.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link href="/">
              <button className="btn-primary w-full sm:w-auto font-press-start hover:scale-105 transition-transform">
                BACK TO HOME
              </button>
            </Link>
            <DownloadButton
              variant="secondary"
              source="vscode"
              className="w-full sm:w-auto font-press-start hover:scale-105 transition-transform"
            >
              JOIN EARLY ACCESS
            </DownloadButton>
          </div>
        </div>

        <p className="mt-8 text-sm text-text opacity-70 font-vt323">
          Questions about future pricing?{" "}
          <a
            href="mailto:hi@trytakeoff.ai"
            className="text-accent underline hover:text-accent-bright"
          >
            Contact us
          </a>
        </p>
      </div>
    </section>
  );
}
